<template>
  <FormRulesProvider :module-name="$constants.REQUEST">
    <DetailView />
  </FormRulesProvider>
</template>

<script>
import FormRulesProvider from '@components/providers/form-rules-provider/form-rules-provider'
import DetailView from './request-detail.vue'

export default {
  name: 'RequestView',
  components: { DetailView, FormRulesProvider },
}
</script>
